import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Button, Card, Col, Row, Empty } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useParams, useHistory } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import useDebounce from "../../../../../customHooks/useDebounce";
import Logo from "../../../../../assets/Logo.png";
import * as dropdownActions from "../../../../../actionCreators/DropDown";
import * as propertyActions from "../../../../../actionCreators/Property";
import * as taxActions from "../../../../../actionCreators/TaxCollection";
import BarChart from "../../graph-plots/bar";
import { customColorFunction } from "../../../../../utils/reportsUtils";


const TaxInspectorReport = (props) => {
  const { selectedTi, selectedCircle } = useParams();
  const history = useHistory();
  const [columnData, setColumnData] = useState([]);


  useEffect(() => {
    if (selectedTi) {
      props.getTiDetails({ tiId: selectedTi });
      props.getTiPropertStats({ tiId: selectedTi, circleId: selectedCircle });
      props.getYearlyPaidTaxTi({ tiId: selectedTi, circleId: selectedCircle });
      props.getTITotalPendingTax({
        tiId: selectedTi,
        circleId: selectedCircle,
      });
    }
  }, [selectedTi]);

  useEffect(() => {
    const currentYear = new Date().getFullYear() + 1;
    const newData = [];
    const intermediate = {};
    props.yearlyPaidTaxTi.data.forEach((element) => {
      intermediate[element.taxyear] = {
        tax: parseInt(element.paidtax),
      };
    });
    for (let i = currentYear - 2; i <= currentYear; i++) {
      if (intermediate[i]) {
        newData.push({
          tax: intermediate[i].tax,
          name: "COLLECTED TAX",
          year: i,
        });
      } else {
        newData.push({
          tax: 0,
          name: "COLLECTED TAX",
          year: i,
        });
      }
    }
    setColumnData(newData);
  }, [props.yearlyPaidTaxTi]);

  useDebounce(
    () => {
      const input = document.getElementById("report");
      html2canvas(input).then((canvas) => {
        var imgWidth = 200;
        var pageHeight = 290;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        var position = 0;
        var heightLeft = imgHeight;
        pdf.addImage(imgData, "JPEG", 7, position, imgWidth, imgHeight);
        // pdf.save("download1.pdf");
        window.open(pdf.output("bloburl"), "_blank");
      });
    },
    [
      columnData,
      props.yearlyPaidTaxTi,
      props.tiDetails,
      props.tiPropertyStats,
      props.totalPendingTaxTi,
    ],
    3000
  );
  return (
    <div style={{ background: "white" }}>
      <div className="close-button-section">
        <Button
          className="close-button"
          // type="primary"
          onClick={() => {
            history.goBack();
          }}
        >
          <ArrowLeftOutlined />
          <span>Back</span>
        </Button>
      </div>
      <div id="report">
        <div className="report-logo">
          <img src={Logo}></img>
          <div className="text-data">ETI Performance Report</div>
        </div>
        <div className="header-details">
          <Typography className="text-label">
            Date :{" "}
            <span className="text-data"> {new Date().toDateString()}</span>
          </Typography>
          <Typography className="text-label">
            District :{" "}
            <span className="text-data">
              {props.tiDetails.data
                ? props.tiDetails.data.user_roles[0].circles[0].zone.district
                    .name
                : "-"}
            </span>
          </Typography>
          <Typography className="text-label">
            Zone :{" "}
            <span className="text-data">
              {props.tiDetails.data
                ? props.tiDetails.data.user_roles[0].circles[0].zone.name
                : "-"}
            </span>
          </Typography>
          <Typography className="text-label">
            ETO :{" "}
            <span className="text-data">
              {props?.tiDetails?.data?.etoName[0]?.full_name}
            </span>
          </Typography>
          <Typography className="text-label">
            Circles :{" "}
            <span className="text-data">
              {props.tiDetails.data
                ? props.tiDetails?.data?.user_roles[0]?.circles.reduce(
                    (reduced, item, index) => {
                      if (index === 0) {
                        return item?.name;
                      }
                      return (reduced += " , " + item?.name);
                    },
                    ""
                  )
                : "-"}
            </span>
          </Typography>
          <Typography className="text-label">
            Tax Inspector :{" "}
            <span className="text-data">
              {props.tiDetails.data ? props.tiDetails.data.full_name : "-"}
            </span>
          </Typography>
        </div>
        <div>
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Card style={{ border: "1px solid black" }}>
                <Typography className="report-stats-header">
                  PROPERTIES REGISTERED
                </Typography>
                <Row>
                  <Col span={12}>
                    <Typography className="report-stats-data">
                      {props.tiPropertyStats.data
                        ? props.tiPropertyStats.data.totalRegistered
                        : "-"}
                      <span
                        style={{
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: "13px",
                          display: "inline",
                          color: "gray",
                        }}
                      >
                        {" "}
                        total
                      </span>
                    </Typography>
                  </Col>
                  <Col span={12}>
                    <Typography className="report-stats-data">
                      {props.tiPropertyStats.data
                        ? props.tiPropertyStats.data.currentFiscalYear
                        : "-"}
                      <span
                        style={{
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: "13px",
                          display: "inline",
                          color: "gray",
                        }}
                      >
                        {" "}
                        current fiscal year
                      </span>
                    </Typography>
                  </Col>
                </Row>
              </Card>
              <br />
              <Card style={{ border: "1px solid black" }}>
                <Typography className="report-stats-header">
                  TOTAL NEW PROPERTIES ASSESSED
                </Typography>
                <Typography className="report-stats-data">
                  {props.tiPropertyStats.data
                    ? props.tiPropertyStats.data.submittedToEto
                    : "-"}
                  <span
                    style={{
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "13px",
                      display: "inline",
                      color: "gray",
                    }}
                  >
                    {" "}
                    submitted to ETO
                  </span>
                </Typography>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Card style={{ border: "1px solid black" }}>
                <Typography className="report-stats-header">
                  TOTAL PROPERTIES AWAITING INSPECTION
                </Typography>
                <Typography className="report-stats-data">
                  {props.tiPropertyStats.data
                    ? props.tiPropertyStats.data.awaitingInspection
                    : "-"}
                </Typography>
              </Card>
              <br />
              <Card style={{ border: "1px solid black" }}>
                <Typography className="report-stats-header">
                  PENDING TAX CURRENT FISCAL YEAR
                </Typography>
                <Typography className="report-stats-data">
                  PKR{" "}
                  {props.totalPendingTaxTi.data
                    ? parseInt(
                        props?.totalPendingTaxTi?.data?.pendingTax
                          ? props?.totalPendingTaxTi?.data?.pendingTax
                          : 0
                      ).toLocaleString()
                    : "-"}
                </Typography>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Card
                title="Collected Tax"
                headStyle={{
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "20px",
                  letterSpacing: "0.15px",
                  border: "none",
                }}
                style={{ border: "1px solid black" }}
              >
                {props?.yearlyPaidTaxTi?.data?.length ? (
                  <BarChart
                  data={columnData}
                  xField="year"
                  yField="tax"
                  xLabel="Fiscal Year"
                  yLabel="Tax (PKR)"
                  customColorFtn={customColorFunction({
                    name: "COLLECTED TAX",
                  })}
                  loading={props?.yearlyPaidTaxTi?.loading}
                  isNoData={!props?.yearlyPaidTaxTi?.data?.length}
                />
                ) : (
                  <Empty />
                )}
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  dropDown: { etoZones, circlesInZone, tisInCircle },
  property: { tiDetails, tiPropertyStats },
  taxCollection: { yearlyPaidTaxTi, totalPendingTaxTi },
  user: { currentUser },
}) => ({
  etoZones,
  circlesInZone,
  tisInCircle,
  tiDetails,
  tiPropertyStats,
  yearlyPaidTaxTi,
  totalPendingTaxTi,
  currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  getEtoZones: bindActionCreators(dropdownActions.getEtoZones, dispatch),
  getCirclesByZone: bindActionCreators(
    dropdownActions.getCirclesByZone,
    dispatch
  ),
  getTisByCircle: bindActionCreators(dropdownActions.getTisByCircle, dispatch),
  getTiDetails: bindActionCreators(propertyActions.getTiDetails, dispatch),
  getTiPropertStats: bindActionCreators(
    propertyActions.getTiPropertStats,
    dispatch
  ),
  getYearlyPaidTaxTi: bindActionCreators(
    taxActions.getYearlyPaidTaxTi,
    dispatch
  ),
  getTITotalPendingTax: bindActionCreators(
    taxActions.getTITotalPendingTax,
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxInspectorReport);
